module.exports = __webpack_public_path__ + "images/home/product/mobile/features-table-09c8654614ea82f40c01ce43808a7201.png";